import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import TooltipSimple from '../tooltips/TooltipSimple.jsx';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
	position: relative;
`;

export default function ButtonFilters({
		open,
		hasFilters,
		closeOnClear = true,
		onToggleCollapse = (state) => { /* */ },
		onFiltersClear = () => { /* */ },
		disabled = false,
	}){

	return (
		<DropdownWrapper>
			<button
				className="btn btn-gc-light-blue-dark font-weight-bold"
				onClick={(e) => {
					e.preventDefault();
					onToggleCollapse(!open)
				}}
				disabled={disabled}
			>
				<span className="mr-md-2">
					<i className="fa-regular fa-filter"></i>
				</span>

				<span className="d-none d-md-inline-block">
					{'filters_button'.trad()}
				</span>

				<span className="ml-2 ml-md-4">
					{open ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
				</span>
			</button>
			
			{ hasFilters && (
				<TooltipSimple 
					title={"supprimer_filtres".trad()}
					placement={'top'}
					style={{ 
						position: 'absolute',
						top: '-0.7rem',
						right: '-0.5rem'
					}}
				>
					<button
						onClick={(e) => {
							e.preventDefault();
							onFiltersClear();
							if (closeOnClear) onToggleCollapse(false);
						}}
						className="btn btn-link text-gc-dark-blue font-weight-bold m-0"
					>
						<i className="fa-solid fa-circle-xmark"></i>
					</button>
				</TooltipSimple>
			)}
		</DropdownWrapper>
	);
}